// src/helpers/buyerPersonaService.js
import { get, post, put, del } from './apiHelper';
import { BUYER_PERSONA_CONFIG } from '../config/buyerPersonaConfig';

const { ENDPOINTS } = BUYER_PERSONA_CONFIG;

const buyerPersonaService = {
    // Obtener preguntas del cuestionario
    getQuestions: async () => {
        try {
            if (process.env.NODE_ENV === 'development') {
                console.log('Fetching questions from:', ENDPOINTS.QUESTIONS);
            }
            const response = await get(ENDPOINTS.QUESTIONS);

            if (process.env.NODE_ENV === 'development') {
                console.log('Questions response type:', typeof response, 'Length:', Array.isArray(response) ? response.length : 'N/A');
            }

            // El backend devuelve directamente el array de preguntas
            if (Array.isArray(response)) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Response is array, questions count:', response.length);
                }
                return { success: true, questions: response };
            } else if (response && response.success && response.questions) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Response has success and questions, count:', response.questions.length);
                }
                return response;
            } else {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Invalid response format:', response);
                }
                throw new Error('Formato de respuesta inválido');
            }
        } catch (error) {
            console.error('Error fetching buyer persona questions:', error);
            throw error;
        }
    },

    // Crear buyer persona (primera vez)
    createBuyerPersona: async (responses) => {
        try {
            const requestBody = { responses };
            const response = await post(ENDPOINTS.CREATE, requestBody);
            return response;
        } catch (error) {
            console.error('Error creating buyer persona:', error);
            throw error;
        }
    },

    // Actualizar buyer persona existente
    updateBuyerPersona: async (responses) => {
        try {
            const requestBody = { responses };
            const response = await put(ENDPOINTS.UPDATE, requestBody);
            return response;
        } catch (error) {
            console.error('Error updating buyer persona:', error);
            throw error;
        }
    },

    // Obtener buyer persona completo con estado de imagen
    getBuyerPersona: async () => {
        try {
            console.log('📤 Solicitando buyer persona al endpoint:', ENDPOINTS.GET_RESULT);
            const response = await get(ENDPOINTS.GET_RESULT);
            console.log('📥 Respuesta getBuyerPersona:', response);
            return response;
        } catch (error) {
            console.error('❌ Error en getBuyerPersona:', error);
            throw error;
        }
    },

    // Verificar estado de generación de imagen
    getImageStatus: async () => {
        try {
            console.log('📤 Verificando estado de imagen en:', ENDPOINTS.IMAGE_STATUS);
            const response = await get(ENDPOINTS.IMAGE_STATUS);
            console.log('📥 Respuesta getImageStatus:', response);
            return response;
        } catch (error) {
            console.error('❌ Error en getImageStatus:', {
                endpoint: ENDPOINTS.IMAGE_STATUS,
                error: error.message,
                stack: error.stack
            });
            throw error;
        }
    },

    // Obtener imagen directamente
    getImage: async (imageId) => {
        try {
            const endpoint = imageId ? `${ENDPOINTS.GET_IMAGE}/${imageId}` : ENDPOINTS.GET_IMAGE;
            console.log('📤 Solicitando imagen desde:', endpoint);
            const response = await get(endpoint);
            console.log('📥 Respuesta getImage:', {
                success: response.success,
                imageUrl: response.imageUrl,
                status: response.status
            });
            return response;
        } catch (error) {
            console.error('❌ Error en getImage:', {
                endpoint: ENDPOINTS.GET_IMAGE,
                imageId,
                error: error.message,
                stack: error.stack
            });
            throw error;
        }
    },

    // Regenerar imagen
    regenerateImage: async () => {
        try {
            console.log('📤 Solicitando regeneración de imagen en:', ENDPOINTS.REGENERATE_IMAGE);
            const response = await post(ENDPOINTS.REGENERATE_IMAGE);
            console.log('📥 Respuesta regenerateImage:', response);
            return response;
        } catch (error) {
            console.error('❌ Error en regenerateImage:', {
                endpoint: ENDPOINTS.REGENERATE_IMAGE,
                error: error.message,
                stack: error.stack
            });
            throw error;
        }
    },

    // Eliminar buyer persona
    deleteBuyerPersona: async () => {
        try {
            const response = await del(ENDPOINTS.DELETE);
            return response;
        } catch (error) {
            console.error('Error deleting buyer persona:', error);
            throw error;
        }
    }
};

export default buyerPersonaService; 